// 不能结构体访问  // 浏览器中不能结构体访问环境变量

// import { isBrowser } from '@/utils';

// const baseURL =
//     process.env.NODE_ENV == 'development' && isBrowser()
//         ? process.env.NEXT_PUBLIC_API_URL
//         : (process.env.NEXT_PUBLIC_API_DOMAIN_NAME || '') + process.env.NEXT_PUBLIC_API_URL

// // 如果是
// const staticBaseURL = process.env.NODE_ENV == 'development' && isBrowser() ? '/data' : process.env.NEXT_PUBLIC_STATIC_DATA_URL

// export { baseURL, staticBaseURL }

// console.log('baseURL=', baseURL)
// console.log('staticBaseURL=', staticBaseURL)
// console.log('process.env.NEXT_PUBLIC_API_DOMAIN_NAME=', process.env.NEXT_PUBLIC_API_DOMAIN_NAME)
// console.log('process.env.NEXT_PUBLIC_API_URL =', process.env.NEXT_PUBLIC_API_URL)

// console.log('process.env.NEXT_PUBLIC_APP_ENV=', process.env.NEXT_PUBLIC_APP_ENV)
// console.log('process.env.NODE_ENV=', process.env.NODE_ENV)
// console.log('process.env.NEXT_PUBLIC_STATIC_URL=', process.env.NEXT_PUBLIC_STATIC_URL)
// console.log('process.env.NEXT_PUBLIC_USER_CENTER_NAME=', process.env.NEXT_PUBLIC_USER_CENTER_NAME)
// console.log('process.env.NEXT_PUBLIC_API_URL =', process.env.NEXT_PUBLIC_API_URL)

const {
    NODE_ENV, // 环境参数
    WEB_ENV, // 环境参数
    target, // 环境参数
    HTML_WEBPACK_PLUGIN_OPTIONS = '',
    APP_ROOT_DIRECTORY,
    DOMAIN_NAME,
    DOMAIN_MIDDLE,
    APP_BASE_URL,
    APP_ENV,
    // # UC 用户中心 pc 域名
    CLIENT_PORTAL_PC_DOMAIN_NAME,

    // # UC 用户中心 Mobile 域名
    CLIENT_PORTAL_MOBILE_DOMAIN_NAME,
} = process.env; // 环境参数

const baseURL = process.env.NODE_ENV == 'development' ? DOMAIN_MIDDLE : DOMAIN_NAME + DOMAIN_MIDDLE;
// const baseURL = '';
// console.log('DOMAIN_MIDDLE==', DOMAIN_NAME);

export { baseURL };
